"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlDetailApp = void 0;
var mobx_react_1 = require("mobx-react");
var React = require("react");
var contexts_1 = require("../../interfaces/contexts");
var api_1 = require("../../api");
var controlDialog_1 = require("./controlDialog");
var App_1 = require("../../App");
var ControlDetailApp = (function (_super) {
    __extends(ControlDetailApp, _super);
    function ControlDetailApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.submitHandler = function () {
            _this.goBack();
        };
        _this.closeHandler = function () {
            App_1.store.controlDialog.closeDialog();
            _this.goBack();
        };
        return _this;
    }
    ControlDetailApp.prototype.componentDidMount = function () {
        var location = window.location.search;
        var params = new URLSearchParams(location);
        var control_id = parseInt(params.get("control_id"));
        if (control_id && !isNaN(control_id)) {
            var context = App_1.store.context.get();
            if (context instanceof contexts_1.ProjectContext) {
                api_1.api.projects.id(context.project).controls.id(control_id).get().then(function (control) {
                    App_1.store.controlDialog.openDialog(control);
                });
            }
        }
    };
    ControlDetailApp.prototype.goBack = function () {
        var location = window.location.search;
        var params = new URLSearchParams(location);
        params.delete("control_id");
        window.history.pushState(null, null, window.location.pathname + "?" + params.toString());
    };
    ControlDetailApp.prototype.render = function () {
        return (React.createElement(controlDialog_1.ControlDialog, { isOpen: App_1.store.controlDialog.isOpen, control: App_1.store.controlDialog.control, applied_tags: App_1.store.controlDialog.applied_tags, available_tags: App_1.store.controlDialog.available_tags, isMandatoryCA: App_1.store.controlDialog.isMandatoryCA, isExclusiveCA: App_1.store.controlDialog.isExclusiveCA, recurrence: App_1.store.controlDialog.recurrence, comments: App_1.store.controlDialog.comments, relations: App_1.store.controlDialog.relations, causality_relations: App_1.store.controlDialog.causality_relations, references: App_1.store.controlDialog.references, entries: App_1.store.controlDialog.entries, availableStatuses: App_1.store.controlDialog.availableStatuses, availableOwners: App_1.store.controlDialog.availableOwners, availableRecurrence: App_1.store.controlDialog.availableRecurrence, controlCosts: App_1.store.controlDialog.controlCosts, availableRiskTargets: App_1.store.controlDialog.availableRiskTargets, udf_types: App_1.store.controlDialog.udf_types, udf_section_header: App_1.store.controlDialog.udf_section_header, onSubmit: this.submitHandler, onClose: this.closeHandler }));
    };
    ControlDetailApp = __decorate([
        mobx_react_1.observer
    ], ControlDetailApp);
    return ControlDetailApp;
}(React.Component));
exports.ControlDetailApp = ControlDetailApp;
